import { useEffect, useState } from "react";
import Axios from "axios";
import { Font } from "@react-pdf/renderer";

const useInitApp = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initApp = async () => {
      const res = await fetch("/api/config");

      const config = await res.json();

      window.__APP_CONFIG__ = config;
      Axios.defaults.baseURL = config.API_URL;

      Font.register({
        family: "opensans",
        fonts: [
          { src: 'assets/fonts/OpenSans-Regular.ttf', fontStyle: "normal" },
          { src: 'assets/fonts/OpenSans-SemiBold.ttf', fontStyle: "bold" },
        ],
      });
      Font.register({ family: "BauerBodoni", src: 'assets/fonts/bauerbodonistd-roman.ttf', fontStyle: "normal" });

      setIsInitialized(true);
    };
    initApp();
  }, []);

  return isInitialized;
};

export default useInitApp;
